import { render, staticRenderFns } from "./AxCardFieldBlank.vue?vue&type=template&id=904bfafa"
import script from "./AxCardFieldBlank.vue?vue&type=script&lang=ts"
export * from "./AxCardFieldBlank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports